import React from 'react'
import PropTypes from 'prop-types'

const AsideOpenButton = ({
  children,
  active,
  openAsideHandler,
  disabled,
  image,
  kind,
}) => (
  <button
    className={`player_bottom_btn ${active ? 'player_bottom_btn_active' : ''}`}
    onClick={() => openAsideHandler(kind)}
    disabled={disabled}
  >
    <div className="player_bottom_icon_wrap">
      <img className="player_bottom_icon" src={image} alt={kind} />
    </div>
    <div className="player_bottom_text">{children}</div>
  </button>
)

export default AsideOpenButton

AsideOpenButton.propTypes = {
  active: PropTypes.bool.isRequired,
  openAsideHandler: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  image: PropTypes.string.isRequired,
  kind: PropTypes.oneOf(['description', 'immersive', 'instruments']),
}
